import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const FilterControls = ({ 
  filters, 
  onFilterChange, 
  onApplyFilters, 
  onResetFilters,
  onExportReport 
}) => {
  const dateRangeOptions = [
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'last90days', label: 'Last 90 Days' },
    { value: 'last6months', label: 'Last 6 Months' },
    { value: 'lastyear', label: 'Last Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const transactionTypeOptions = [
    { value: 'all', label: 'All Transaction Types' },
    { value: 'residential', label: 'Residential' },
    { value: 'commercial', label: 'Commercial' },
    { value: 'industrial', label: 'Industrial' },
    { value: 'land', label: 'Land' }
  ];

  const stakeholderRoleOptions = [
    { value: 'all', label: 'All Stakeholders' },
    { value: 'lawyer', label: 'Lawyers' },
    { value: 'engineer', label: 'Engineers' },
    { value: 'notary', label: 'Notaries' },
    { value: 'owner', label: 'Property Owners' }
  ];

  const metricTypeOptions = [
    { value: 'completion', label: 'Completion Rates' },
    { value: 'velocity', label: 'Transaction Velocity' },
    { value: 'compliance', label: 'Compliance Metrics' },
    { value: 'efficiency', label: 'Processing Efficiency' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-soft">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Report Filters</h3>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onResetFilters}
            iconName="RotateCcw"
            iconPosition="left"
          >
            Reset
          </Button>
          <Button
            variant="default"
            size="sm"
            onClick={onApplyFilters}
            iconName="Filter"
            iconPosition="left"
          >
            Apply Filters
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={filters?.dateRange}
          onChange={(value) => onFilterChange('dateRange', value)}
          className="w-full"
        />

        <Select
          label="Transaction Type"
          options={transactionTypeOptions}
          value={filters?.transactionType}
          onChange={(value) => onFilterChange('transactionType', value)}
          className="w-full"
        />

        <Select
          label="Stakeholder Role"
          options={stakeholderRoleOptions}
          value={filters?.stakeholderRole}
          onChange={(value) => onFilterChange('stakeholderRole', value)}
          className="w-full"
        />

        <Select
          label="Metric Type"
          options={metricTypeOptions}
          value={filters?.metricType}
          onChange={(value) => onFilterChange('metricType', value)}
          className="w-full"
        />
      </div>
      {filters?.dateRange === 'custom' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 p-4 bg-muted/50 rounded-lg">
          <Input
            label="Start Date"
            type="date"
            value={filters?.startDate}
            onChange={(e) => onFilterChange('startDate', e?.target?.value)}
          />
          <Input
            label="End Date"
            type="date"
            value={filters?.endDate}
            onChange={(e) => onFilterChange('endDate', e?.target?.value)}
          />
        </div>
      )}
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <span>Last updated:</span>
          <span className="font-mono">{new Date()?.toLocaleString()}</span>
        </div>
        
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onExportReport('pdf')}
            iconName="FileText"
            iconPosition="left"
          >
            Export PDF
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onExportReport('excel')}
            iconName="FileSpreadsheet"
            iconPosition="left"
          >
            Export Excel
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onExportReport('csv')}
            iconName="Download"
            iconPosition="left"
          >
            Export CSV
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;